module.exports = __webpack_public_path__ + "img/loader.1332c4b1.gif";